  <template>
  <div class="main-container">
    <p style="color: red;font-weight: bold;">Note: Click on "calculate" button to view the latest tax simulation.</p>
    <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />  
    <div class="bg-gray" v-if="!itEnableValue">
      <img class="warning-img" src="@/assets/warning.svg" alt />
      <span class="investment-alert-message">Income Tax Declaration window is not enabled for the Month.</span>
    </div>  
    <div :disabled="false" class="dashboardContainer">
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Saved Successfully.`"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
      <div class="dashboardContainer__first">
        <div class="first__header">
          <div class="first__name">
            <h3>{{ employee_name }} ({{ employee_code }})</h3>
            <p>Tax Calculator and Tax Declaration Year {{ payrollFinancialYear }}</p>
          </div>
          <div class="first__button" @click="getItDashboard()">
            <button>Calculate</button>
          </div>
        </div>
        <table class="reportTable">
          <thead>
            <tr>
              <th>Particulars</th>
              <th style="text-align: right;">Amount</th>
              <th style="text-align: right;">New Regime(INR)</th>
              <th style="text-align: right;">Old Regime(INR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Taxable Salary(A)</td>
              <td>
                {{ totalGrossSalary }}
              </td>
              <td>{{ totalGrossSalary }}</td>
              <td>{{ totalGrossSalary }}</td>
            </tr>
            <!-- <tr>
              <td>Less: Sec 10 Exemption</td>
              <td>
                <txt class="inputText" type="text" v-model="formData.sectionTenExemption" />
              </td>
              <td>-</td>
              <td>-</td>
            </tr> -->
            <tr class="col-row-box">
              <td class="hover-on-text" @click="showPopupHraExemeption = !showPopupHraExemeption">
                HRA Exemption
              </td>
              <td>{{ formData.hraExemptionAmount }}</td>
              <td>0</td>
              <td>{{ formData.sectionTenExemption  && Math.round(formData.sectionTenExemption)}}</td>
            </tr>
            <tr class="col-row-box">
              <td class="hover-on-text" @click="showPopupSection10Exemeption = !showPopupSection10Exemeption">
                Section 10 Exemption
              </td>
              <td>{{ formData.sectionTenExemptionAmount }}</td>
              <td>0</td>
              <td>{{ formData.sectionTenOtherExemption  && Math.round(formData.sectionTenOtherExemption)}}</td>
            </tr>
            <!-- <tr>
              <td>Other Exemption</td>
              <td>
                <input class="inputText" type="text" v-model="formData.otherExemption">
              </td>
              <td>-</td>
              <td>-</td>
            </tr> -->
            <!-- <tr>
              <td>Total Sec 10 Exemption (B)</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr> -->
            <tr>
              <td>Net Salary</td>
              <td></td>
              <td>{{ formData.netSalary.newRegime && Math.round(formData.netSalary.newRegime) }}</td>
              <td>{{ formData.netSalary.oldRegime && Math.round(formData.netSalary.oldRegime) }}</td>
            </tr>
            <!-- <tr>
              <td>Less : Deduction U/s 16</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr> -->
            <tr>
              <td>Standard Deduction (D)</td>
              <td>{{ formData.section16.stdOldDeduction && Math.round(formData.section16.stdOldDeduction)  }}</td>
              <td>{{ formData.section16.stdNewDeduction && Math.round(formData.section16.stdNewDeduction)  }}</td>
              <td>{{ formData.section16.stdOldDeduction && Math.round(formData.section16.stdOldDeduction)  }}</td>
            </tr>
            <tr>
              <td>Tax on Employment (E)</td>
              <td>{{ formData.section16.ptAMT && Math.round(formData.section16.ptAMT)  }}</td>
              <td>0</td>
              <td>{{ formData.section16.ptAMT && Math.round(formData.section16.ptAMT)  }}</td>
            </tr>
            <tr>
              <td>Net Taxable Salary F=(D-E)</td>
              <td></td>
              <td>{{ formData.netTaxableSalary.newRegime && Math.round(formData.netTaxableSalary.newRegime)  }}</td>
              <td>{{ formData.netTaxableSalary.oldRegime && Math.round(formData.netTaxableSalary.oldRegime)  }}</td>
            </tr>
            <tr class="col-row-box">
              <td class="hover-on-text" @click="showPopupincomeLossfromHouseProperty = !showPopupincomeLossfromHouseProperty">
                Income/Loss from House Property (G)
              </td>
              <td>{{ formData.incomeFromHousingProperty.grandTotal }}</td>
              <td>{{ formData.section24.newRegime && Math.round(formData.section24.newRegime) }}</td>
              <td>{{ formData.section24.oldRegime && Math.round(formData.section24.oldRegime) }}</td>
            </tr>
            <tr class="col-row-box">
              <td class="hover-on-text" @click="showPopupincomeFromOtherSources = !showPopupincomeFromOtherSources">
                Income from Other Sources (H)
              </td>
              <td>{{ formData.incomeFromOtherSourceTotal }}</td>
              <td>{{ formData.incomeFromOtherSourceTotal }}</td>
              <td>{{ formData.incomeFromOtherSourceExemption }}</td>
            </tr>
            <tr>
              <td>Gross Total Income I= (G-H)</td>
              <td></td>
              <td>{{ formData.grossTotalIncome.newRegime && Math.round(formData.grossTotalIncome.newRegime)  }}</td>
              <td>{{ formData.grossTotalIncome.oldRegime && Math.round(formData.grossTotalIncome.oldRegime)  }}</td>
            </tr>
            <tr>
              <td class="col-row-box hover-on-text" @click="showPopuplessDeductionUnderChapterVIA = !showPopuplessDeductionUnderChapterVIA">
                Deduction under Chapter VIA (J)
              </td>
              <td>{{ formData.chapterVIA.grandTotal }}</td>
              <td>{{ formData.deductionUnderV1AExemption.newRegime && formData.deductionUnderV1AExemption.newRegime }}</td>
              <td>{{ formData.deductionUnderV1AExemption.oldRegime && formData.deductionUnderV1AExemption.oldRegime }}</td>
            </tr>
            <tr v-if="isFirstMonth">
              <td class="col-row-box hover-on-text" @click="IncomeFromPreviousEmployer = !IncomeFromPreviousEmployer">
                Income From Previous Employer
              </td>
              <!-- <td>{{ formData.previousEmployerAmount }}</td>
              <td>{{ formData.previousEmployerAmount }}</td>
              <td>{{ formData.previousEmployerAmount }}</td> -->
            </tr>
            <tr>
              <td>Taxable Income (I-J)</td>
              <td></td>
              <td>{{ formData.taxableIncome.newRegime && Math.round(formData.taxableIncome.newRegime)  }}</td>
              <td>{{ formData.taxableIncome.oldRegime && Math.round(formData.taxableIncome.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Taxable Income(Rounded Off)</td>
              <td></td>
              <td>{{ Math.round(formData.taxableIncome.newRegime) }}</td>
              <td>{{ Math.round(formData.taxableIncome.oldRegime) }}</td>
            </tr>
            <tr>
              <td>Tax Payable on Total Income</td>
              <td></td>
              <td>{{ formData.taxPayableOnTotalIncome.newRegime }}</td>
              <td>{{ formData.taxPayableOnTotalIncome.oldRegime }}</td>
            </tr>
            <tr>
              <td>Less Relief U/s 87 A</td>
              <td></td>
              <td>{{ formData.rebate.newRegime && Math.round(formData.rebate.newRegime) }}</td>
              <td>{{ formData.rebate.oldRegime && Math.round(formData.rebate.oldRegime) }}</td>
            </tr>
            <tr>
              <td>Tax Payable (K)</td>
              <td></td>
              <td>{{ formData.taxPayable.newRegime && Math.round(formData.taxPayable.newRegime)  }}</td>
              <td>{{ formData.taxPayable.oldRegime && Math.round(formData.taxPayable.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Add Surcharge (L)</td>
              <td></td>
              <td>{{ formData.surcharge.newRegime && Math.round(formData.surcharge.newRegime)  }}</td>
              <td>{{ formData.surcharge.oldRegime && Math.round(formData.surcharge.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Add Cess (M)</td>
              <td></td>
              <td>{{ formData.cess.newRegime && Math.round(formData.cess.newRegime)  }}</td>
              <td>{{ formData.cess.oldRegime && Math.round(formData.cess.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Total Tax Payable P =(K+L+M)</td>
              <td></td>
              <td>{{ formData.totalTaxPayable.newRegime && Math.round(formData.totalTaxPayable.newRegime)  }}</td>
              <td>{{ formData.totalTaxPayable.oldRegime && Math.round(formData.totalTaxPayable.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Less Relief U/s 89 (Q)</td>
              <td>{{ formData.reliefUs89 }}</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr class="taxPayable">
              <td>Total Tax Payable(Rounded Off) R= P-Q</td>
              <td></td>
              <td>{{ formData.totalTaxPayableRoundOff.newRegime && Math.round(formData.totalTaxPayableRoundOff.newRegime)  }}</td>
              <td>{{ formData.totalTaxPayableRoundOff.oldRegime && Math.round(formData.totalTaxPayableRoundOff.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Less</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Tax Recovered Till Previous Month</td>
              <td></td>
              <td>{{ formData.paidTillPrevMonth.newRegime && Math.round(formData.paidTillPrevMonth.newRegime) }}</td>
              <td>{{ formData.paidTillPrevMonth.oldRegime && Math.round(formData.paidTillPrevMonth.oldRegime) }}</td>
            </tr>
            <tr>
              <td>Tax Deducted Current month</td>
              <td></td>
              <td>{{ formData.currentMonthTax.newRegime && Math.round(formData.currentMonthTax.newRegime)  }}</td>
              <td>{{ formData.currentMonthTax.oldRegime && Math.round(formData.currentMonthTax.oldRegime)  }}</td>
            </tr>
            <!-- <tr>
              <td>Previous Employment Tax</td>
              <td>
                <txt class="inputText" type="text" v-model="formData.previousEmployeMentTax" />
              </td>
              <td>-</td>
              <td>-</td>
            </tr> -->
            <tr>
              <td>Total Tax Deducted (S)</td>
              <td></td>
              <td>{{ formData.totalTaxDeducted.newRegime && Math.round(formData.totalTaxDeducted.newRegime)  }}</td>
              <td>{{ formData.totalTaxDeducted.oldRegime && Math.round(formData.totalTaxDeducted.oldRegime)  }}</td>
            </tr>
            <tr>
              <td>Balance Tax Payable for the remaining xx months (R-S)</td>
              <td></td>
              <td>{{ formData.balanceTaxPayableForRemaingMonth.newRegime && Math.round(formData.balanceTaxPayableForRemaingMonth.newRegime)  }}</td>
              <td>{{ formData.balanceTaxPayableForRemaingMonth.oldRegime && Math.round(formData.balanceTaxPayableForRemaingMonth.oldRegime)  }}</td>
            </tr>
            <tr class="taxPayable">
              <td>Monthly tax (Balance tax Payable/ Remaining Months)</td>
              <td></td>
              <td>{{ formData.monthlyTax.newRegime && Math.round(formData.monthlyTax.newRegime) }}</td>
              <td>{{ formData.monthlyTax.oldRegime && Math.round(formData.monthlyTax.oldRegime) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="dashboardContainer__second">
        <div class="second__top">
          <div class="it-heading-text">Income Tax Declaration</div>
          <div id="chart">
            <apexchart type="donut"  :options="chartOptions" :series="series"></apexchart>
          </div>
          <div class="it-sub-text">
            <div class="deduction-img">
              <img class="icon-i" src="@/assets/info-2.svg" alt />
              <span>{{ taxMessage }}</span>
            </div>
          </div>
        </div>
        <div class="second__bottom">
          <div class="it-heading-text" v-if="isDeclared == 'false'">Select the Regime</div>
          <div class="regime-box">
            <div class="radio-btn" v-if="isDeclared == 'false'">
              <tl-radio
                name="regime"
                label="Old Regime"
                id="oldregime"
                value="oldregime"
                v-model="data2.regime_type"
                @change="(val)=>{data2.regime_type = val}"
              /> 
              <tl-radio
                name="regime"
                label="New Regime"
                id="newregime"
                value="newregime"
                v-model="data2.regime_type"
                @change="(val)=>{data2.regime_type = val}"
              />
            </div>
            <div class="terms" v-if="isDeclared == 'false'">
              <p>Terms & Conditions<span style="color: red;">*</span></p>
              <div>
                <tl-checkbox
                label=''
                name="notice"
                id="notice"
                v-model="notice"
              />
              <span>I have understood the impact of choosing the tax regime and decided to select the above tax regime.</span>
              </div>          
            </div> 
              <!-- <btn-grp>
                <popup-btn
                    text="Cancel"
                    type="secondary"
              />
                <popup-btn text="Submit" type="primary" />
              </btn-grp> -->
              <div class="cancel__button">
                <button class="cancel-button" v-show="isDeclared == 'true'" @click="goBackToDeclaration">Cancel</button>
                <button class="submit-button" @click="submit" v-if="itEnableValue && isDeclared == 'false'">Submit</button>
              </div>

              <pop-up-message v-if="showConfirmSubmit"
                :message="le_id !== '6c228af4-a9ad-42c2-b688-ae823b386d88' ? 'Are you Sure? Once you select the regime and Submit, you shall not be allowed to modify it later. In case of New Tax Regime being opted, you shall not be allowed for FBP Declaration or Claim.  Select your regime wisely.' : 'Are you Sure? Once you select the regime and Submit, you shall not be allowed to modify it later. Select your regime wisely.'"
                :popupType="popupType"
                :popupHeaderMessage="'Confirm Submit!'"
              >
                <template v-slot:bottomContent>
                  <div class="popup-btn-group">
                    <button class="btn-popup-secondary" type="button" @click="cancelEvent">Cancel</button>
                    <button class="btn-popup" type="button" @click="saveTaxRegime">Confirm</button>
                  </div>
                </template>
              </pop-up-message>

              <hr class="horizontalRule">
              <div class="disclaimer">
                  <p><img class="" src="@/assets/info-2.svg" alt />Disclaimer</p>
                  <span>The Tax simulator is only illustrative and provided for the broader understanding on the basis of information given by the employee. The calculation of tax is on the basis of the current fixed salary components excluding any varible payments/incentives. Please update the investment declaration section with actual values of investment and other income to avail the relevant benefits while processing the salary.</span>
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup 1 for HRA Exemption -->
    <pop-up-window-lg
      v-if="showPopupHraExemeption"
      @back="showPopupHraExemeption = !showPopupHraExemeption"
      header="HRA Exemption"
    >
      <template v-slot:content>
        <hra-exemption-popup
          @back="showPopupHraExemeption = !showPopupHraExemeption"
          :HraFormData = "formData.Exemption10"
          @hraExemption="hraExemptionFun"
          :itEnableValue ="itEnableValue"
        >
        </hra-exemption-popup>
      </template>
    </pop-up-window-lg>

    <pop-up-window-lg
      v-if="showPopupSection10Exemeption"
      @back="showPopupSection10Exemeption = !showPopupSection10Exemeption"
      header="Section 10 Exemption"
    >
      <template v-slot:content>
        <section-ten-exemption
          @back="showPopupSection10Exemeption = !showPopupSection10Exemeption"
          :HraFormData = "formData.Exemption10"
          @section10Exemption="section10ExemptionFun"
          :itEnableValue = "itEnableValue"
        >
        </section-ten-exemption>
      </template>
    </pop-up-window-lg>
    <!-- End here Popup 1 -->

    <!-- Popup 2 for Income/Loss from House Property -->
    <pop-up-window-lg
      v-if="showPopupincomeLossfromHouseProperty"
      @back="showPopupincomeLossfromHouseProperty = !showPopupincomeLossfromHouseProperty"
      header="Income or Loss From House Property"
    >
      <template v-slot:content>
        <income-loss-from-house-property-popup
          @back="showPopupincomeLossfromHouseProperty = !showPopupincomeLossfromHouseProperty"
          :Section24="formData.incomeFromHousingProperty"
          @incomeLossFromHousingProperty="incomeLossFromHousingProperty"
          :itEnableValue = "itEnableValue"
        >
        </income-loss-from-house-property-popup>
      </template>
    </pop-up-window-lg>
    <!-- End here Popup 2 -->

    <!-- Popup 3 for Income from Other Sources (H) -->
    <pop-up-window-lg
      v-if="showPopupincomeFromOtherSources"
      @back="showPopupincomeFromOtherSources = !showPopupincomeFromOtherSources"
      header="Income From Other Sources"
    >
      <template v-slot:content>
        <income-from-other-sources-popup
          @back="showPopupincomeFromOtherSources = !showPopupincomeFromOtherSources"
          :IncomeOtherSource="formData.incomeFromOtherSource"
          @incomeFromOtherSource="incomeFromOtherSource"
          :itEnableValue = "itEnableValue"
        >
        </income-from-other-sources-popup>
      </template>
    </pop-up-window-lg>
    <!-- End here Popup 3 -->

    <!-- Popup 4 for Less : Deduction under Chapter VIA (J) -->
    <pop-up-window-lg
      v-if="showPopuplessDeductionUnderChapterVIA"
      @back="
        showPopuplessDeductionUnderChapterVIA =
          !showPopuplessDeductionUnderChapterVIA
      "
      header="Less : Deduction under Chapter VIA (J)"
    >
      <template v-slot:content>
        <less-deduction-under-chapter-VIA-popup
          @back="showPopuplessDeductionUnderChapterVIA = !showPopuplessDeductionUnderChapterVIA"
          :ChapterVIA="formData.deductionUnderV1A"
          @chapterVIA="chapterVIA"
          :itEnableValue="itEnableValue"
        >
        </less-deduction-under-chapter-VIA-popup>
      </template>
    </pop-up-window-lg>
    <pop-up-window-lg
      v-if="IncomeFromPreviousEmployer"
      @back="
        IncomeFromPreviousEmployer =
          !IncomeFromPreviousEmployer
      "
      header="Income From Previous Employer"
    >
      <template v-slot:content>
        <incomeFromPreviousEmployer
          @back="IncomeFromPreviousEmployer = !IncomeFromPreviousEmployer"
          :previousEmploymentDetails="formData.previousEmploymentDetails"
          @previousDataUpdate="previousDataUpdate"
          :itEnableValue = "itEnableValue"
        >
        </incomeFromPreviousEmployer>
      </template>
    </pop-up-window-lg>
    <!-- End here Popup 4 -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment';
import hraExemptionPopup from "./itDeclarationDashboardPopup/hraExemptionPopup.vue";
//import incomeLossFromHousePropertyPopup from "./itDeclarationDashboardPopup/incomeLossfromHousePropertyPopup.vue";
import incomeLossFromHousePropertyPopup from "./itDeclarationDashboardPopup/incomeFromHousePropertyPopUp.vue"
import incomeFromOtherSourcesPopup from "./itDeclarationDashboardPopup/incomeFromOtherSourcesPopup.vue";
import lessDeductionUnderChapterVIAPopup from "./itDeclarationDashboardPopup/lessDeductionUnderChapterVIAPopup.vue";
import incomeFromPreviousEmployer from "./itDeclarationDashboardPopup/incomeFromPreviousEmployerPopUp.vue";
import sectionTenExemption from "./itDeclarationDashboardPopup/section10OtherExemption.vue"

export default {
  components: {
    incomeFromPreviousEmployer,
    hraExemptionPopup,
    incomeLossFromHousePropertyPopup,
    incomeFromOtherSourcesPopup,
    lessDeductionUnderChapterVIAPopup,
    sectionTenExemption
  },
  data() {
    return {
      itEnableValue: false,
      showConfirmSubmit: false,
      startDate: "",
      endDate: "",
      tempGrossSalary: 0,
      prevEmployerAmount: 0,
      totalGrossSalary: 0,
      tempManualSalary: 0,
      rentPaidMonths: 0,
      monthsForProratedSalary: 0,
      date_of_joining: null,
      isFirstMonth: false,
      it_financial_year: "",
      selectYear: null,
      selectMonth: null,
      errmsg: null,
      popupType: 'ConfirmDelete',
      toast: false,
      showSuccessMsg: false,
      employee_id: "",
      //grossSalaryAmount: 56800,
      otherExemption: {
        amount: 0,
        new: 0,
        old: 0,
      },
      netSalary: {
        amount: 0,
        new: 0,
        old: 0,
      },
      stdDeduction: {
        amount: 0,
        new: 0,
        old: 0,
      },
      stdNewDeduction: 0,
      stdOldDeduction: 0,
      employmentTax: {
        amount: 0,
        new: 0,
        old: 0,
      },
      instance:{},
      taxMessage: "",
      notice: null,
      incomeLossHouseProperty: {},
      showPopupHraExemeption: false,
      showPopupincomeLossfromHouseProperty: false,
      showPopupincomeFromOtherSources: false,
      showPopuplessDeductionUnderChapterVIA: false,
      IncomeFromPreviousEmployer:false,
      showPopupSection10Exemeption: false,
      data2:{
      exemption10:[],
      exemption17:[],
      deductionsUnderSection16:[],
      deductionsUnderChapterVIA:[],
      section24:[],
      previousEmploymentDetails:{},
      otherIncome:[],
      le_id:"",
      employee_id:"",
      financial_year:"",
      plan_id:"",
      regime_type:"",
      },
      formData: {
        section24:{},
        currentMonthTax: {},
        totalGross: 0,
        sectionTenExemption: 0,
        sectionTenOtherExemption: 0,
        Exemption10: {
        HRA: {},
        others: []
      },
        hraExemptionAmount: 0,
        sectionTenExemptionAmount: 0,
        otherExemption: 0,
        netSalary: 0,
        section16: {
          stdDeduction: 0,
          stdNewDeduction: 0,
          stdOldDeduction:0,
        },
        netTaxableSalary: 0,
        incomeFromOtherSource: {
          
        },
        previousEmploymentDetails: {},
        previousEmployerAmount: 0,
        incomeFromOtherSourceTotal: 0,
        incomeFromHousingProperty: {

        },
        grossTotalIncome: 0,
        deductionUnderV1A: {},
        deductionUnderV1A80CCD: {
          npsEmployerContribution: 0,
        },
        chapterVIA: {
          grandTotal: 0
        },
        deductionUnderV1AExemption: {},
        incomeFromOtherSourceExemption: 0,
        taxableIncome: {
          newRegime: 0,
          oldRegime: 0,
        },
        taxPayableOnTotalIncome:{
          newRegime: 0,
          oldRegime: 0,
        },
        rebate: {
          newRegime: 0,
          oldRegime: 0,
        },
        taxPayable: {
          newRegime: 0,
          oldRegime: 0,
        },
        surcharge: {
          newRegime: 0,
          oldRegime: 0,
        },
        cess: {
          newRegime: 0,
          oldRegime: 0,
        },
        totalTaxPayable: {
          newRegime: 0,
          oldRegime: 0,
        },
        reliefUs89: 0,
        totalTaxPayableRoundOff: {
          newRegime: 0,
          oldRegime: 0,
        },
        previousEmployeMentTax: 0,
        totalTaxDeducted: {
          newRegime: 0,
          oldRegime: 0,
        },
        balanceTaxPayableForRemaingMonth: {
          newRegime: 0,
          oldRegime: 0,
        },
        monthlyTax: {
          newRegime: 0,
          oldRegime: 0,
        },
        paidTillPrevMonth: {
          
        }
      },
      employee_name: "",
      employee_code: "",
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
        },
        legend: {
          position: 'bottom'
        },
        dataLabels: {
            enabled: false
        },
        labels: ["Tax under New Regime", "Tax under Old Regime"],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
          }
        }]
      },
    };
  },

  mounted() {
    //this.getEmployeeData();
    this.getItPlan();
    this.itStatusEnable();
  },

  activated() {
    //this.getEmployeeData();
    this.getItPlan();
    this.itStatusEnable();
  },

  computed: {
    le_id(){
      return localStorage.getItem("le_id")
    },

    empId(){
      return localStorage.getItem("empId")
    },

    isDeclared(){
      return sessionStorage.getItem("isDeclared")
    },

    payrollFinancialYear() {
      if (this.selectMonth > 8) {
        return `${ this.it_financial_year - 1 } - ${ this.it_financial_year }`
      } else {
        return `${ this.it_financial_year } - ${ Number(this.it_financial_year) + 1 }`
      }
    },

  },

  methods: {
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_get_itDashboard_data:
        "dashboard/payroll/monthlypayroll/employeeProfile/fetchItDashboardData",
      act_get_plan:"dashboard/payroll/incometax/getPlan",
      act_set_it_data:"dashboard/payroll/incometax/setItData", 
      act_save_it_plan:"dashboard/payroll/incometax/createItData",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll', 
      act_get_it_enable:"dashboard/payroll/incometax/getItEnable"
    }),
    async submit() {
      this.showConfirmSubmit = true;
    },
    cancelEvent() {
      this.showConfirmSubmit = false;
    },
  closeConfirmSubmitPopup() {
    this.showConfirmSubmit = false;
  },
    async getEmployeeData() {
      try {
        let obj = {
          'employee_id': this.empId
        };
        let response = await this.act_getProfileData(obj);
        this.employee_name = response.data.payload[0].first_name;
        this.employee_code = response.data.payload[0].code;
        this.date_of_joining = response.data.payload[0].date_of_joining;
        this.it_financial_year = response.data.payload[0].payrollDetails.year;
        let month = response.data.payload[0].payrollDetails.month;
        this.selectMonth = this.getCurrentMonthIndex(month);
        let year = this.date_of_joining.split("-")[0];
        let joiningMonth = this.date_of_joining.split("-")[1];
        let dateOfJoin = this.date_of_joining.split("T")[0].split("-")[2]
        this.isFirstMonth = Number(joiningMonth) == 4 && (dateOfJoin && Number(dateOfJoin) > 1) ? true : Number(joiningMonth) > 4 ? true : false;
        this.getItDashboard();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getItPlan() {
      try {
        await this.getEmployeeData();
        let res = await this.act_get_plan(this.empId)
        this.planList = res.data.payload.filter( ele => ele.is_plan_active == true);
        this.it_plan_id = this.planList[0].id;
        if(this.it_plan_id){
          this.fetchRecord();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      } 
    },

    async fetchRecord() {
      this.instance.employee_id = this.empId;
      this.instance.financial_year = this.it_financial_year;
      this.instance.it_plan_id = this.it_plan_id;
      this.instance.le_id = this.le_id;
      let res = await this.act_set_it_data(this.instance)
      if(res.data.payload){
        this.formData.deductionUnderV1A = res.data.payload.deductionsUnderChapterVIA;
        this.formData.deductionUnderV1A.map(element => {
          if(!element.hasOwnProperty("planned")){
            element.planned = 0;
          }
        })
        this.chapterVIA(this.formData.deductionUnderV1A)
        if(res.data.payload.Exemption10 && Object.keys(res.data.payload.Exemption10).length > 0){
          this.formData.Exemption10 = res.data.payload.Exemption10;
          if(res.data.payload.Exemption10.HRA && res.data.payload.Exemption10.HRA.planned){
            this.hraExemptionFun(this.formData.Exemption10)
          }
          if(res.data.payload.Exemption10.others && res.data.payload.Exemption10.others.length){
            this.section10ExemptionFun(this.formData.Exemption10)
          }
        }
        // this.data2.exemption10 = res.data.payload.Exemption10;
        // this.data2.previousEmploymentDetails = res.data.payload.previousEmploymentDetails;
        if(res.data.payload.otherIncome && res.data.payload.otherIncome.length > 0){
          this.formData.incomeFromOtherSource = res.data.payload.otherIncome;
          this.incomeFromOtherSource(this.formData.incomeFromOtherSource)
        }
        if(Object.keys(res.data.payload.section24).length > 0){
          this.formData.incomeFromHousingProperty = res.data.payload.section24;
          this.incomeLossFromHousingProperty(this.formData.incomeFromHousingProperty)
          this.calculateSection24Total(this.formData.incomeFromHousingProperty);
        }
        if(res.data.payload.previousEmploymentDetails && Object.keys(res.data.payload.previousEmploymentDetails).length > 0){
          this.formData.previousEmploymentDetails = res.data.payload.previousEmploymentDetails;
          this.previousDataUpdate(this.formData.previousEmploymentDetails)
        }
      }
    },

    async getItDashboard() {
      try {
        let tempObj = this.formData && this.formData.Exemption10 && this.formData.Exemption10.HRA && this.formData.Exemption10.HRA.planned && this.formData.Exemption10.HRA.planned.details.length > 0 ? this.formData.Exemption10.HRA.planned.details[this.formData.Exemption10.HRA.planned.details.length - 1] : null;
        let isMetro = tempObj && tempObj.ownerDetails && tempObj.ownerDetails.metro == "non_metro" ? false : true;
        let obj = {
              employee_id:this.empId,
              grossSalary: Number(this.tempManualSalary > 0) ? Number(this.tempManualSalary) : Number(this.tempGrossSalary),
              section24: this.formData.incomeFromHousingProperty.grandTotal,
              rentPaidMonths: this.rentPaidMonths,
              monthsForProratedSalary: this.monthsForProratedSalary,
              incomeFromOtherSource: this.formData.incomeFromOtherSourceTotal,
              deductionUnderV1A: this.formData.deductionUnderV1A,
              incomeFromPrevEmployer: this.formData.previousEmploymentDetails,
              reliefUs89:0,
              sectionTenExemption:this.formData.hraExemptionAmount ? this.formData.hraExemptionAmount : 0,
              sectionTenOtherExemptions: this.formData.sectionTenExemptionAmount ? this.formData.sectionTenExemptionAmount : 0,
              sectionTenExemptionNewRegime:{
              leaveEncashment: 0,
              gratuity:0,
              voluntaryRetirement: 0,
              relocationAllowance:0,
              travelAllowance: 0
              },
              eightyCCD:{
                npsErContribution: this.formData.deductionUnderV1A80CCD.npsEmployerContribution ? this.formData.deductionUnderV1A80CCD.npsEmployerContribution : 0
              },
              section17:{
              perquisites:0
              },
              regimeType: "",
              metro: isMetro
            };
        //console.log(obj);
        let data = await this.act_get_itDashboard_data(obj);
        this.formData.totalGross = data.data.payload.totalGross && Number(Math.round(data.data.payload.totalGross));
        this.tempGrossSalary = data.data.payload.grossSalary && Number(Math.round(data.data.payload.grossSalary));
        this.prevEmployerAmount = data.data.payload.incomefromPrevEmp && Number(Math.round(data.data.payload.incomefromPrevEmp));
        this.totalGrossSalary = this.tempGrossSalary + this.prevEmployerAmount;
        this.formData.sectionTenExemption =
          data.data.payload.sectionTenExemption;
        this.formData.sectionTenOtherExemption = data.data.payload.sectionTenOtherExemptions;
        this.formData.section24 = data.data.payload.section24Obj;
        // if(Math.sign(this.formData.incomeFromHousingProperty.grandTotal) == -1){
        //   this.formData.section24.oldRegime = -this.formData.section24.oldRegime;
        // }
        this.formData.deductionUnderV1AExemption = data.data.payload.deductionUnderV1A;
        //this.formData.hraExemption = data.data.payload.hraExemption;
        this.formData.otherExemption = data.data.payload.otherExemption;
        this.formData.netSalary = data.data.payload.netSalary;
        this.formData.section16.stdDeduction =
          data.data.payload.section16.stdDeduction;
          this.formData.section16.stdNewDeduction =
          data.data.payload.section16.stdNewDeduction;
          this.formData.section16.stdOldDeduction =
          data.data.payload.section16.stdOldDeduction;
        this.formData.section16.ptAMT = data.data.payload.section16.ptAMT;
        this.formData.netTaxableSalary = data.data.payload.netTaxableSalary;
        this.formData.incomeFromOtherSource.totalAmount =
          data.data.payload.incomeFromOtherSource;
        this.formData.grossTotalIncome = data.data.payload.grossTotalIncome;
        //this.formData.deductionUnderV1A.grandTotal = data.data.payload.deductionUnderV1A;
        this.formData.taxableIncome.newRegime =
          data.data.payload.taxableIncome.newRegime;
        this.formData.taxableIncome.oldRegime =
          data.data.payload.taxableIncome.oldRegime;
        this.formData.taxPayable.newRegime =
          data.data.payload.taxPayable.newRegime;
        this.formData.taxPayable.oldRegime =
          data.data.payload.taxPayable.oldRegime;
        this.formData.surcharge.newRegime =
          data.data.payload.surcharge.newRegime;
        this.formData.surcharge.oldRegime =
          data.data.payload.surcharge.oldRegime;
        this.formData.cess.newRegime = data.data.payload.cess.newRegime;
        this.formData.cess.oldRegime = data.data.payload.cess.oldRegime;
        this.formData.totalTaxPayable.newRegime =
          data.data.payload.totalTaxPayable.newRegime;
        this.formData.totalTaxPayable.oldRegime =
          data.data.payload.totalTaxPayable.oldRegime;
        this.formData.reliefUs89 = data.data.payload.reliefUs89;
        this.formData.totalTaxPayableRoundOff.newRegime =
          data.data.payload.totalTaxPayableRoundOff.newRegime;
        this.formData.totalTaxPayableRoundOff.oldRegime =
          data.data.payload.totalTaxPayableRoundOff.oldRegime;
        this.formData.previousEmployeMentTax =
          data.data.payload.previousEmployeMentTax;
        this.formData.totalTaxDeducted.newRegime =
          data.data.payload.totalTaxDeducted.newRegime;
        this.formData.totalTaxDeducted.oldRegime =
          data.data.payload.totalTaxDeducted.oldRegime;
        this.formData.balanceTaxPayableForRemaingMonth.newRegime =
          data.data.payload.balanceTaxPayableForRemaingMonth.newRegime;
        this.formData.balanceTaxPayableForRemaingMonth.oldRegime =
          data.data.payload.balanceTaxPayableForRemaingMonth.oldRegime;
        this.formData.currentMonthTax = data.data.payload.currentMonthTax;
        this.formData.monthlyTax = data.data.payload.monthlyTax;
        this.formData.paidTillPrevMonth = data.data.payload.paidTillPrevMonth;
        this.formData.rebate.newRegime = data.data.payload.rebate.newRegime;
        this.formData.rebate.oldRegime = data.data.payload.rebate.oldRegime;
        this.formData.incomeFromOtherSourceExemption = data.data.payload.incomeFromOtherSource;
        this.formData.taxPayableOnTotalIncome = data.data.payload.tax;
        let arrayOne = [];
        arrayOne.push(data.data.payload.totalTaxPayableRoundOff.newRegime);
        arrayOne.push(data.data.payload.totalTaxPayableRoundOff.oldRegime);
        this.series = arrayOne;
        this.createText();
        //this.createChart();
        //this.formData.otherExemption = data.data.payload.
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    // createChart() {
    //   this.series = [];
    //   this.series.push(this.formData.hraExemptionAmount);
    //   this.series.push(this.formData.incomeFromHousingProperty.grandTotal);
    //   this.series.push(this.formData.incomeFromOtherSourceTotal);
    //   this.series.push(this.formData.chapterVIA.grandTotal);
    // },

    // createDoughnutChart() {
    //   let config = {
    //     type: "doughnut",
    //     data: {
    //       datasets: [
    //         {
    //           data: [40, 20, 80, 10],
    //           backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
    //           //label: 'Dataset 1'
    //         },
    //       ],
    //       labels: [
    //         "HRA Exemptions",
    //         "Income/loss from House Property",
    //         "Income from Other Sources",
    //         "Deduction under VI(A)",
    //       ],
    //     },
    //     options: {
    //       responsive: true,
    //       plugins: {
    //         legend: {
    //           position: "bottom",
    //         },
    //       },
    //     },
    //   };

    //   let ctx = document.getElementById("chart-area").getContext("2d");
    //   let doughnutChart = new Chart(ctx, config);
    // },

    createText(){
      let newTax = this.formData.totalTaxPayableRoundOff.newRegime ? this.formData.totalTaxPayableRoundOff.newRegime : 0;
      let oldTax = this.formData.totalTaxPayableRoundOff.oldRegime ? this.formData.totalTaxPayableRoundOff.oldRegime : 0;
      let differential = newTax - oldTax;
      //let b = oldTax - newTax;
      if(differential >= 0){
        this.taxMessage = `Tax benefit as per the Old regime is Rs ${differential}.`
      }else{
        this.taxMessage = `Tax benefit as per the New regime is Rs ${Math.abs(differential)}.`
      }
    },

    changeInSalary(e){
      this.tempManualSalary = e.target.value;
    },

    getCurrentMonthIndex(monthName) {
      try {
        switch (monthName) {
          case 'jan':
            this.currentMonthIndex = 9;
            break;
          case 'feb':
            this.currentMonthIndex = 10;
            break;
          case 'mar':
            this.currentMonthIndex = 11;
            break;
          case 'apr':
            this.currentMonthIndex = 0;
            break;
          case 'may':
            this.currentMonthIndex = 1;
            break;
          case 'jun':
            this.currentMonthIndex = 2;
            break;
          case 'jul':
            this.currentMonthIndex = 3;
            break;
          case 'aug':
            this.currentMonthIndex = 4;
            break;
          case 'sep':
            this.currentMonthIndex = 5;
            break;
          case 'oct':
            this.currentMonthIndex = 6;
            break;
          case 'nov':
            this.currentMonthIndex = 7;
            break;
          case 'dec':
            this.currentMonthIndex = 8;
            break;
          default:
            break;
        }
        return this.currentMonthIndex;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    updateSelfOccupiedPlanned() {
      if (this.data2.section24 && this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned !== undefined) {
        this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned > 0
          ? -this.data2.section24.self_occupied.total_planned
          : this.data2.section24.self_occupied.total_planned;
      }
    },
    async saveTaxRegime() {
      this.closeConfirmSubmitPopup();
      this.data2.plan_id=this.it_plan_id;
      this.data2.employee_id=this.empId;
      this.data2.financial_year= this.it_financial_year;
      this.data2.le_id=this.le_id;
      this.data2.itDeclarationStatus = "true";
      this.data2.isEmployee= "true"
      await this.updateSelfOccupiedPlanned();
      // this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned > 0 ? -this.data2.section24.self_occupied.total_planned : this.data2.section24.self_occupied.total_planned;
      if(this.notice && this.data2.regime_type){
        this.showConfirmationMsg = false;
        let res = await this.act_save_it_plan(this.data2);
      if(res.status){
        this.showSuccessMsg = true;
      }else{
        this.showSuccessMsg = false;
      }
    }else{
      this.toast = true;
      window.scrollTo(0,0)
      this.errmsg = "Please select the regime type and accept the Terms & Conditions"
    }
      
    },

    goBack(){
      this.showSuccessMsg = false;
      sessionStorage.setItem('isDeclared', "true");
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclaration`,
      });
      window.location.reload();
    },

    goBackToDeclaration(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclaration`,
      });
    },

    mapMonthToFinancialYear(date) {
    let month = date.split('-')[1]
    const monthMappings = {
      '04': 12,
      '05': 11,
      '06': 10,
      '07': 9,
      '08': 8,
      '09': 7,
      '10': 6,
      '11': 5,
      '12': 4,
      '01': 3,
      '02': 2,
      '03': 1
    };

    // Return the corresponding month from the mappings
    return monthMappings[month];
  },

    calculateMonthsFromDateToToDate(fromDate, toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);

      // Calculate the difference in months
      let months = (to.getFullYear() - from.getFullYear()) * 12;
      months -= from.getMonth(); // Months before start month
      months += to.getMonth() + 1; // Months after end month

      return months;
    },

    formattedDateData(){
      this.data2.exemption10.HRA.planned.details = this.data2.exemption10 && this.data2.exemption10.HRA.planned.details.map(item => ({
        ...item,
        from: moment(item.from).format('YYYY-MM-DD'),
        to: moment(item.to).format('YYYY-MM-DD')
      }));
    },

    hraExemptionFun(data) {
      this.formData.hraExemptionAmount= 0;
      this.rentPaidMonths = 0,
      this.monthsForProratedSalary = 0;
      this.showPopupHraExemeption = false;
      this.formData.Exemption10 = data;
      let montfromto = 0
      this.data2.exemption10 = data;
      this.formData.Exemption10.HRA.planned.details && this.formData.Exemption10.HRA.planned.details.map(element => {
        // this.formData.hraExemptionAmount += Number(element.value);
        if(element.value > 0){
          const monthsBetween = this.calculateMonthsFromDateToToDate(element.from, element.to);
          montfromto += monthsBetween
          this.formData.hraExemptionAmount += monthsBetween * Number(element.value)
          this.rentPaidMonths = montfromto;
        }
        // let monthMappings = this.mapMonthToFinancialYear(this.formData.Exemption10.HRA.planned.details[0].from)
        // console.log(monthMappings,'monthMappings');
        // this.monthsForProratedSalary = monthMappings;
        this.monthsForProratedSalary++;
      })
      this.formattedDateData();
      this.series[0] = this.formData.hraExemptionAmount;
      // this.formData.Exemption10.others && this.formData.Exemption10.others.map(element => {
      //   if(!element.hasOwnProperty("planned")){
      //     element.planned = 0;
      //   }
      //   this.formData.sectionTenExemptionAmount += Number(element.planned);
      // })
      //console.log("Data hraExemptionFun---->", data);
    },

    section10ExemptionFun(data){
      this.formData.sectionTenExemptionAmount= 0;
      // this.rentPaidMonths = 0,
      // this.monthsForProratedSalary = 0;
      this.showPopupSection10Exemeption = false;
      this.formData.Exemption10 = data;
      this.data2.exemption10 = data;
      this.formData.Exemption10.others && this.formData.Exemption10.others.map(element => {
        if(!element.hasOwnProperty("planned")){
          element.planned = 0;
        }
        this.formData.sectionTenExemptionAmount += Number(element.planned);
      })
      // this.series[0] = this.formData.hraExemptionAmount;
    },

    incomeLossFromHousingProperty(data) {
      this.showPopupincomeLossfromHouseProperty = false;
      this.formData.incomeFromHousingProperty = data;
      this.data2.section24 = data;
      //this.createChart();
    },

    previousDataUpdate(previousEmpData) {
      this.formData.previousEmployerAmount = 0;
      this.IncomeFromPreviousEmployer = false;
      this.formData.previousEmploymentDetails = previousEmpData;
      this.data2.previousEmploymentDetails = previousEmpData;
      let preEmployerData = Object.values(this.data2.previousEmploymentDetails);
      preEmployerData.map(element => {
        this.formData.previousEmployerAmount += element.planned;
      })
    },

    incomeFromOtherSource(data){
      this.formData.incomeFromOtherSourceTotal = 0;
      this.showPopupincomeFromOtherSources = false;
      this.formData.incomeFromOtherSource = data;
      this.data2.otherIncome = data;
      this.formData.incomeFromOtherSource.map(element => {
        this.formData.incomeFromOtherSourceTotal += Number(element.planned)
      })
      //this.createChart();
    },

    chapterVIA(data){
      //console.log(data);
      this.formData.chapterVIA.grandTotal = 0;
      this.showPopuplessDeductionUnderChapterVIA = false;
      this.formData.deductionUnderV1A = data;
      this.data2.deductionsUnderChapterVIA = data;
      this.formData.deductionUnderV1A && this.formData.deductionUnderV1A.map(element => {
        let name = element.InvestmentComponentType ? element.InvestmentComponentType.name : element.name
        if( name == "NPS Employer Contribution"){
          this.formData.deductionUnderV1A80CCD.npsEmployerContribution = element.planned
        }
      })
      this.formData.deductionUnderV1A.map(element => {
        this.formData.chapterVIA.grandTotal += element.planned;
      })
      //this.createChart();
    },

    calculateSection24Total(data){
      // console.log(data, 'data');
      let result = 0;
      let self_occupied_total_planned = 0;
      let total
      // let total= 0;
      let self_occupied_tax_benefit = data.self_occupied && data.self_occupied.tax_benefit;
      if(self_occupied_tax_benefit > 0){
        let tax_benefit_perc = data.self_occupied && data.self_occupied.total_planned * (self_occupied_tax_benefit/100);
        self_occupied_total_planned = data.self_occupied && data.self_occupied.total_planned - tax_benefit_perc;
      }else{
        self_occupied_total_planned = data.self_occupied && data.self_occupied.total_planned
      }
      data.let_out_property && data.let_out_property.map(el => {
        result += el.total_planned
      });
      this.formData.incomeFromHousingProperty.grandTotal = (this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned + result < -200000) ? -200000 : this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned + result;  
    },

    async itStatusEnable() {
      let res = await this.act_get_it_enable({le_id:this.le_id});
      let time = new Date();
      let day = time.getDate();
      ////console.log("Time", day);
      
      this.itEnableValue = res.data.payload.data.ITDeclarationSetting.ITEnable;
      this.startDate = res.data.payload.data.ITDeclarationSetting.startDate;
      this.endDate = res.data.payload.data.ITDeclarationSetting.endDate;
      // day >= this.startDate && day <= this.endDate ? this.itEnableValue = true : this.itEnableValue = false;
     // //console.log("IT Enable", this.itEnableValue,this.startDate, this.endDate);
      
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.dashboardContainer {
  display: flex;
  gap: 20px;
}

.dashboardContainer__first {
  width: 70%;
  /* background-color: #f5f5f5; */
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  box-shadow: 0px 1px 2px #f0f0f0;
  padding: 20px 0;
}

.first__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #34c0bd;
  padding: 0 20px 10px;
}

.first__header .first__name > h3 {
  color: #34c0bd;
  font-size: 1rem;
  margin-bottom: 5px;
}

.first__header .first__name > p {
  margin: 0;
  font-size: 0.9rem;
}

.first__header .first__button {
  background-color: #34c0bd;
  color: #ffffff;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 8px;
}

.dashboardContainer__second {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.second__top {
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  box-shadow: 0px 1px 2px #f0f0f0;
  /* padding: 20px 0;  */
  padding: 20px 0 0;
}
/* 
.second__top__canvas{
  height: 250px !important;
} */

.second__bottom {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  box-shadow: 0px 1px 2px #f0f0f0;
  padding: 20px 0 10px;
}
.reportTable {
  border-collapse: collapse;
  font-size: 1rem;
  min-width: 100%;
}

.reportTable thead tr {
  height: 50px;
  text-align: left;
  border-bottom: 0.5px solid #dddddd;
}

.reportTable th,
.reportTable td {
  padding: 10px 20px 8px;
  font-size: 1rem;
}

.reportTable tbody tr {
  margin-top: 10px;
  border-bottom: 0.5px solid #dddddd;
}

.reportTable tbody tr:last-child {
  border-bottom: none;
}

// .reportTable tbody > tr > td:first-child{
//   width: 350px;
// }

.reportTable tbody > tr > td:not(:first-child){
  text-align: right;
  padding-right: 20px;
}


.hover-on-text {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: #34c0bd;
}

/* .col-row-box:hover {
  box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;
  background: rgb(175 196 195 / 50%);
  cursor: pointer;
  color: #3f51b5;
} */

.hover-on-text:hover {
  font-weight: bold;
}

.it-heading-text {
  //text-align: center;
  border-bottom: 2px solid #34c0bd;
  padding-bottom: 14px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #34c0bd;
  margin-bottom: 10px;
  padding-left: 20px;
}

.it-sub-text {
  margin-top: 15px;
  padding: 14px;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
  background: #9e9ea229;
  border-radius: 0px 0px 8px 8px;
}

.deduction-img {
  text-align: left;
  transform: translate(0px, 0px);
  font-size: 1rem;
}

.deduction-img > span{
  margin-left: 10px;
}

.icon-i {
  margin: 0px;
  transform: translate(0px, 7px);
}

// .btn-text-center {
//   margin-left: 30px;
// }

.inputText{
  max-width: 140px;
  text-align: right;
  padding: 8px 8px;
  border-radius: 5px;
  border: 1px solid #dadada;
}

.inputText:focus{
  outline: none;
  border: 2px solid #34c0be;
}

.radio-btn {
  display: flex;
  margin-top: 18px;
  padding: 0 15px;
  font-weight: 500;
}

.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

.submit-button {
  background-color: #34c0bd;
  color: #ffffff;
  padding: 7px 24px 7px 24px;
  font-weight: bold;
  border-radius: 4px;
  min-width: 124px;
  position: relative;
  min-height: 33px;
}

.cancel__button{
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 20px;
  padding: 15px 20px;
}

.cancel-button {
  border: #34c0be solid 1px;
  color: #34c0be;
  border-radius: 4px;
  font-weight: bold;
  min-width: 124px;
  padding: 7px 24px 7px 24px;
  position: relative;
}

.cancel-button:hover {
  background-color: #e2f7f7;
}

.disclaimer{
  padding: 8px 15px;
}
.disclaimer > p{
  font-size: 1rem;
  color: #777777;
  font-weight: bold;
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.disclaimer > span {
  font-weight: 500;
  color: #444444;
}

.taxPayable{
  font-weight: bold;
}

.terms{
  padding: 15px;
}

.terms > div {
  display: flex;
  align-items: center;
  color: #444444;
  font-weight: 500;
}

.terms > p{
  margin-bottom: 8px;
  color: #777777;
  font-weight: bold;
}

.horizontalRule{
  margin: 8px 15px;
  height:0.1px;
  border-width:0;
  color: #e4dfdf;
  background-color:#e4dfdf;
}

.bg-gray {
  background-color: #f2f2f2;
  padding: 10px 20px;
  height: 60px;
  margin: 20px 0;
}

.warning-img {
  height: 25px;
  width: 25px;
  margin-right: 15px;
  transform: translate(5px, 5px);
}

.investment-alert-message {
  font-size: 14px;
  font-weight: 600;
}
</style>
  